// extracted by mini-css-extract-plugin
export default {"modal":"styles_modal__WYNqk","window":"styles_window__mfRcT","wrapper":"styles_wrapper__D9JHe","title":"styles_title__twj7V","buttons":"styles_buttons__MAVxT"};